export default "__VITE_ASSET__PjsHL7Wm__"